export const lists_games = [
    {
        "code": "nl_NL",
        "url": "https://meldkamerspel.com/"
    },
    {
        "code": "de_DE",
        "url": "https://www.leitstellenspiel.de/"
    },
    {
        "code": "en_AU",
        "url": "https://www.missionchief-australia.com/"
    },
    {
        "code": "en_US",
        "url": "https://www.missionchief.com/"
    },
    {
        "code": "en_GB",
        "url": "https://www.missionchief.co.uk/"
    },
    {
        "code": "es_ES",
        "url": "https://www.centro-de-mando.es/"
    },
    {
        "code": "pl_PL",
        "url": "https://www.operatorratunkowy.pl/"
    },
    {
        "code": "sv_SE",
        "url": "https://www.larmcentralen-spelet.se/"
    },
    {
        "code": "it_IT",
        "url": "https://www.operatore112.it/"
    },
    {
        "code": "fr_FR",
        "url": "https://www.operateur112.fr/"
    },
    {
        "code": "ru_RU",
        "url": "https://www.dispetcher112.ru/"
    },
    {
        "code": "da_DK",
        "url": "https://www.alarmcentral-spil.dk/"
    },
    {
        "code": "nb_NO",
        "url": "https://www.nodsentralspillet.com/"
    },
    {
        "code": "cs_CZ",
        "url": "https://www.operacni-stredisko.cz/"
    },
    {
        "code": "tr_TR",
        "url": "https://www.112-merkez.com/"
    },
    {
        "code": "pt_PT",
        "url": "https://www.jogo-operador112.com/"
    },
    {
        "code": "pt_BR",
        "url": "https://www.operador193.com/"
    },
    {
        "code": "uk_UA",
        "url": "https://www.dyspetcher101-game.com/"
    },
    {
        "code": "ko_KR",
        "url": "https://www.missionchief-korea.com/"
    },
    {
        "code": "es_MX",
        "url": "https://www.centro-de-mando.mx/"
    },
    {
        "code": "ja_JP",
        "url": "https://www.missionchief-japan.com/"
    },
    {
        "code": "ro_RO",
        "url": "https://www.jocdispecerat112.com/"
    },
    {
        "code": "fi_FI",
        "url": "https://www.hatakeskuspeli.com/"
    },
    {
        "code": "sk_SK",
        "url": "https://www.dispecerske-centrum.com/"
    }
]
